/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const AndroidBack = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M13 3.55728L11.9361 2.5L3.44068 10.9427C2.85311 11.5266 2.85311 12.4734 3.44068 13.0573L11.9361 21.5L13 20.4427L5.25925 12.75H21V11.25H5.25925L13 3.55728Z"
                        fill={color}
                    />
                </svg>
        );
    };
